'use client';

import { DragDropContext, Droppable, DropResult } from '@hello-pangea/dnd';
import DragCard from '@fe-news/components/atoms/Member/DragCard';
import { styled } from '@linaria/react';

const List = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  width: 100%;
  height: 360px;
  overflow-y: auto;
`;

type DragListProps = {
  title: string;
  isPopTopic: boolean;
  onClickDeleteItem: (tag: string) => void;
  list: string[];
  trackListTitle?: Map<string, string>;
  onClickSetData: (data: string[]) => void;
};

const DragList = ({ list, title, isPopTopic, onClickDeleteItem, trackListTitle, onClickSetData }: DragListProps) => {
  const onDragEnd = (result: DropResult) => {
    const { destination, source } = result;
    if (!destination) return;
    const items = [...list];
    const [newItems] = items.splice(source.index, 1);
    items.splice(destination.index, 0, newItems);
    onClickSetData(items);
  };

  const onTop = (name: string) => {
    const items = [...list];
    const item = items.find(item => item === name);
    if (!item) return;
    const newItems = items.filter(item => item !== name);
    newItems.unshift(item);
    onClickSetData(newItems);
  };

  const onDelete = (name: string) => {
    const items = [...list];
    const newItems = items.filter(item => item !== name);
    onClickDeleteItem(name);
    onClickSetData(newItems);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={`droppable-${title}`} isDropDisabled={!isPopTopic}>
        {(droppableProvided, snapshot) => (
          <List ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
            {list.map((id, index) => (
              <DragCard
                key={id}
                id={id}
                index={index}
                onTop={onTop}
                name={isPopTopic ? trackListTitle?.get(id) ?? id : id}
                isPopTopic={isPopTopic}
                onDelete={onDelete}
              />
            ))}
            {droppableProvided.placeholder}
          </List>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragList;
